import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EcatService {
  constructor(private http: HttpClient) { }

  getBrand(params: any) {
    const headers = new HttpHeaders().set('isEcat', 'true');
    return this.http.get<any>('/car/brand/query', { params: params, headers: headers });
  }

  //获取热门品牌
  getHotBrand(params: any) {
    const headers = new HttpHeaders().set('isEcat', 'true');
    return this.http.get<any>('/car/brand/hot-brand', { params: params, headers: headers });
  }

  getVinCode(params: any) {
    const headers = new HttpHeaders().set('isEcat', 'true');
    return this.http.post<any>('/car/getVinCode', params, { headers });
  }

  fileUpload(params: any) {
    params = { file: '' }
    const headers = new HttpHeaders().set('isEcat', 'true');
    return this.http.post<any>('/file/upload', params, { headers });
  }

  //按照品牌搜索
  seriesList(params: any) {
    const headers = new HttpHeaders().set('isEcat', 'true');
    return this.http.get<any>('/car/series/list', { params: params, headers: headers });
  }

  //获取车型
  modelList(params: any) {
    const headers = new HttpHeaders().set('isEcat', 'true');
    return this.http.get<any>('/car/model/list', { params: params, headers: headers });
  }

  //获取车型，排量，年款
  modelYearDisplacementList(params: any) {
    const headers = new HttpHeaders().set('isEcat', 'true');
    return this.http.get<any>('/car/model-year/displacement/list', { params: params, headers: headers });
  }

  //通过品牌和车型, 获取排量
  displacementList(params: any) {
    const headers = new HttpHeaders().set('isEcat', 'true');
    return this.http.get<any>('/car/displacement/list', { params: params, headers: headers });
  }

  //通过品牌和车型，排量, 获取年款和车辆
  modelyearList(params: any) {
    const headers = new HttpHeaders().set('isEcat', 'true');
    return this.http.get<any>('/car/model-year/list', { params: params, headers: headers });
  }

  //查询车辆信息
  carQuery(params: any) {
    const headers = new HttpHeaders().set('isEcat', 'true');
    return this.http.get<any>('/car/query', { params: params, headers: headers });
  }

  //按照VIN码查询
  queryVinCode(params: any) {
    const headers = new HttpHeaders().set('isEcat', 'true');
    return this.http.get<any>('/car/query-vinCode', { params: params, headers: headers });
  }

  //根据车辆信息获取产品组
  getCategoryByCarList(params: any) {
    const headers = new HttpHeaders().set('isEcat', 'true');
    return this.http.post<any>('/part/category/global/getCategoryByCarList', params, { headers });
  }

  //搜索配件
  partList(params: any) {
    const headers = new HttpHeaders().set('isEcat', 'true');
    return this.http.get<any>('/part/global/list', { params: params, headers: headers });
  }

  //搜索配件
  fuzzySearch(params: any) {
    const headers = new HttpHeaders().set('isEcat', 'true');
    return this.http.get<any>('/car/search/keyword', { params: params, headers: headers });
  }

  //搜索配件
  partCarQuery(params: any) {
    const headers = new HttpHeaders().set('isEcat', 'true');
    return this.http.get<any>('/part/car/web/query', { params: params, headers: headers });
  }

  //添加匹配报错信息
  submitErrorReport(params: any) {
    const headers = new HttpHeaders().set('isEcat', 'true');
    return this.http.post<any>('/feedback/add', params, { headers });
  }

    //添加匹配报错信息
  uploadFile(params: any) {
    const headers = new HttpHeaders().set('isEcat', 'true');
    return this.http.post<any>('/file/upload', params, { headers });
  }

  //根据料号列表查询配件详情
  getPartListByPartNos(partNos: string[], page: number = 1, pageSize: number = 100) {
    const headers = new HttpHeaders().set('isEcat', 'true');
    return this.http.post<any>('/part/global/part-nos/list', { partNos, page, pageSize }, { headers });
  }

  // //搜索配件
  // searchMatchedCars(params: any) {
  //   const headers = new HttpHeaders().set('isEcat', 'true');
  //   return this.http.get<any>('/car/query', { params: params, headers: headers });
  // }
  // //搜索配件
  // searchMatchedCarBrands(params: any) {
  //   const headers = new HttpHeaders().set('isEcat', 'true');
  //   return this.http.get<any>('/car/brand/query', { params: params, headers: headers });
  // }
}
